module.exports = __webpack_public_path__ + "img/point.e6971c04.png";